export const STN2 = 'STN2'
export const CX_IS = 'CX-IS'
export const CX_OPS = 'CX-OPS'
export const IT = 'IT'
export const SALES = 'SALES'
export const HEAD = 'HEAD'

const headAccess = [IT, HEAD, CX_OPS, STN2]
export { headAccess }
